
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointNextFilled as ObiWaypointNextFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-next-filled.js';
 
 
 

 
 export const ObiWaypointNextFilled = createComponent({
   react: React,
   tagName: 'obi-waypoint-next-filled',
   elementClass: ObiWaypointNextFilledElement,
   events: {
     
   }
  });
 
 